export const GENERATE_ZIP = 'MEDIAS/GENERATE/ZIP/POST_REQUEST';
export const GENERATE_ZIP_SUCCESS = 'MEDIAS/GENERATE/ZIP/POST_SUCCESS';

export const GET_ZIP = 'MEDIAS/ZIP/GET_REQUEST';
export const GET_ZIP_SUCCESS = 'MEDIAS/ZIP/GET_SUCCESS';
export const GET_ZIP_FAILURE = 'MEDIAS/ZIP/GET_FAILURE';

export const UPLOAD_TWO_STEPS = 'MEDIAS/TWO_STEPS/UPLOAD_REQUEST';
export const UPLOAD_TWO_STEPS_SUCCESS = 'MEDIAS/TWO_STEPS/UPLOAD_SUCCESS';
export const UPLOAD_TWO_STEPS_FAILURE = 'MEDIAS/TWO_STEPS/UPLOAD_FAILURE';

export const CLEAR_UPLOADED_MEDIAS = 'MEDIAS/UPLOAD/CLEAR';
export const FLUSH_UPLOADED_MEDIAS = 'MEDIAS/UPLOAD/FLUSH';

export const APPLY_TRANSFORMATIONS = 'MEDIAS/TRANSFORM/TRANSFORM_REQUEST';
export const APPLY_TRANSFORMATIONS_SUCCESS = 'MEDIAS/TRANSFORM/TRANSFORM_SUCCESS';
export const APPLY_TRANSFORMATIONS_FAILURE = 'MEDIAS/TRANSFORM/TRANSFORM_FAILURE';

export const DELETE_MEDIA = 'MEDIAS/DELETE_REQUEST';
export const DELETE_MEDIA_SUCCESS = 'MEDIAS/DELETE_SUCCESS';

export const UPLOAD_MEDIAS = 'MEDIAS/UPLOAD/REQUEST';
export const UPLOAD_MEDIAS_SUCCESS = 'MEDIAS/UPLOAD/SUCCESS';
export const UPLOAD_MEDIAS_FAILURE = 'MEDIAS/UPLOAD/FAILURE';

export const PATCH_MEDIA = 'MEDIA/PATCH/REQUEST';
export const PATCH_MEDIA_SUCCESS = 'MEDIA/PATCH/SUCCESS';

export const DOWNLOAD_MEDIA = 'MEDIA/DOWNLOAD/REQUEST';
export const DOWNLOAD_MEDIA_SUCCESS = 'MEDIA/DOWNLOAD/SUCCESS';
export const DOWNLOAD_MEDIA_FAILURE = 'MEDIA/DOWNLOAD/FAILURE';

export const PERSIST_ITEMS_TO_ENTITY = 'MEDIA_LIBRARY/PERSIST_ITEM_REQUEST';
export const PERSIST_ITEMS_TO_ENTITY_SUCCESS = 'MEDIA_LIBRARY/PERSIST_ITEM_SUCCESS';
export const PERSIST_ITEMS_TO_ENTITY_FAILURE = 'MEDIA_LIBRARY/PERSIST_ITEM_FAILURE';

export const GET_TEMPLATE = 'MEDIAS/TEMPLATE/GET_REQUEST';
export const GET_TEMPLATE_SUCCESS = 'MEDIAS/TEMPLATE/GET_SUCCESS';
export const GET_TEMPLATE_FAILURE = 'MEDIAS/TEMPLATE/GET_FAILURE';

// Relative to new Cold Storage for medias
export const DEFROST_MEDIAS_REQUEST = 'MEDIAS/DEFROSTING/DEFROST_REQUEST';
export const DEFROST_MEDIAS_SUCCESS = 'MEDIAS/DEFROSTING/DEFROST_SUCCESS';
export const DEFROST_MEDIAS_FAILURE = 'MEDIAS/DEFROSTING/DEFROST_FAILURE';
export const CLEAR_DEFROSTING_MEDIA = 'MEDIAS/DEFROSTING/CLEAR_DEFROSTING_MEDIA';
